<script>
    import 'firebase/firestore';

    import { db } from '../../firebase';
    import { user } from '../../store'
    import { docData } from 'rxfire/firestore';
    import { onMount } from 'svelte';
    
    import CardList from '../../components/organisms/CardList/CardList.svelte';

    let ideas = [];
    let loading = true;   

    function fetchBookmarks(data) {
        ideas = []; // reset if already filled
        if(data.length){
            data.forEach((id, i) => {
                const docRef = db.doc(`ideas/${id}`);
                docRef.get()
                .then((doc) => {
                    let dataObj = doc.data();
                    dataObj.id = id;
                    ideas = [...ideas, dataObj];
                })
                .then(() => loading = false);
            });
        }else {
            loading = false;
        }
    }

    // get YOUR saved / bookmarked ideas
    onMount(() => {
        const userQuery = docData(db.collection('users').doc($user.uid));
        userQuery.subscribe((data) => fetchBookmarks(data.saved));
    });

</script>
<CardList {ideas} {loading} page="vault"/>